import React from 'react';
import { Col } from 'reactstrap';
import './index.css';

type RequiredTextProps = { error?: string };

const RequiredText = ({ error }: RequiredTextProps) =>
  error ? (
    <Col className={'i-required-text'}>
      <em className={'i-information-text'}>{error}</em>
    </Col>
  ) : null;

export default RequiredText;
